import { useState } from "react";
import { useBetween } from "use-between";

const useFormState = () => {
  const [eventsData, setEventsData] = useState(new Map());
  const [coachesData, setCoachesData] = useState(new Map());
  const [usersData, setUsersData] = useState([{}]);
  const [modifiedEvents, setModifiedEvents] = useState(new Map());
  const [deletedEvents, setDeletedEvents] = useState([]);
  const [teamsData, setTeamsData] = useState(new Map());
  const [schedulerAccount, setSchedulerAccount] = useState("");
  return {
    eventsData,
    setEventsData,
    usersData,
    setUsersData,
    teamsData,
    setTeamsData,
    coachesData,
    setCoachesData,
    modifiedEvents,
    setModifiedEvents,
    deletedEvents,
    setDeletedEvents,
    schedulerAccount,
    setSchedulerAccount,
  };
};
export const useSharedFormState = () => useBetween(useFormState);
